import { render, staticRenderFns } from "./FinalExamProtocolsFinal.vue?vue&type=template&id=58e7e592"
import script from "./FinalExamProtocolsFinal.vue?vue&type=script&lang=js"
export * from "./FinalExamProtocolsFinal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports